import { getHeaders } from 'src/api/headers'
import { ins } from 'src/api/axios'
import { getError } from 'src/api/utils'

export interface PassPageDocumentResponse {
    document: Record<string, unknown>
}

export const getPassPageDocument = async (
    userId: string,
    zoneId: string,
    language: string,
): Promise<PassPageDocumentResponse | Error> => {
    const link = encodeURI(`/v1/fm/payments/users/${userId}/pass-page-document?zoneId=${zoneId}&language=${language}`)
    const headers = await getHeaders()
    return ins
        .get(link, { headers })
        .then(res => res.data)
        .catch(e => getError(e, 'response.data.errors[0]'))
}

export const getProductOfferPageDocument = async (
    userId: string,
    zoneId: string,
    productOfferId: string,
    language: string,
): Promise<PassPageDocumentResponse | Error> => {
    const link = encodeURI(
        `/v1/fm/payments/users/${userId}/product-offer-page-document?zoneId=${zoneId}&productOfferId=${productOfferId}&language=${language}`,
    )
    const headers = await getHeaders()
    return ins
        .get(link, { headers })
        .then(res => res.data)
        .catch(e => getError(e, 'response.data.errors[0]'))
}
